module.exports = __webpack_public_path__ + "static/img/4.a9858a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/realisations/fletrePortail/4.png
// module id = raGn
// module chunks = 0